import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createPOEntry = createAsyncThunk('createPOEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPO`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const createPOExtraEntry = createAsyncThunk('createPOExtraEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPOExtra`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertTempBaleLump = createAsyncThunk('insertTempBaleLump', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertBaleLumpDetails`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPoNo = createAsyncThunk('fetchPoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=PoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPOData = createAsyncThunk('fetchPOData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPOList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAllPONumbers = createAsyncThunk('fetchAllPONumbers', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPOnumbers`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPOExtra = createAsyncThunk('fetchPOExtra', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPOExtraList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAllPOExtraNumbers = createAsyncThunk('fetchAllPOExtraNumbers', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPOExtraNumbers`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchTempBaleLump = createAsyncThunk('fetchTempBaleLump', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getBaleLumpDetails&clothId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const removePOExtraCloth = createAsyncThunk('removePOExtraCloth', async (Ids) => {
    const { poId, clothId } = Ids;

    try {
        const response = await axios.get(`${baseUrl}?apicall=removePOExtraCloths&poId=${poId}&clothId=${clothId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const poNoSlice = createSlice({
    name: 'PoNoData',
    initialState: {
        isLoading: false,
        PoNo: null,
        podata: null,
        allPONo: null,
        poExtra: null,
        allPOExtraNo: null,
        removeCloth: null,
        tempBale: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.PoNo = action.payload;
        });
        builder.addCase(fetchPoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchPOData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPOData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.podata = action.payload;
        });
        builder.addCase(fetchPOData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchAllPONumbers.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAllPONumbers.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allPONo = action.payload;
        });
        builder.addCase(fetchAllPONumbers.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPOExtra.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPOExtra.fulfilled, (state, action) => {
            state.isLoading = false;
            state.poExtra = action.payload;
        });
        builder.addCase(fetchPOExtra.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchAllPOExtraNumbers.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAllPOExtraNumbers.fulfilled, (state, action) => {
            state.isLoading = false;
            state.allPOExtraNo = action.payload;
        });
        builder.addCase(fetchAllPOExtraNumbers.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(removePOExtraCloth.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(removePOExtraCloth.fulfilled, (state, action) => {
            state.isLoading = false;
            state.removeCloth = action.payload;
        });
        builder.addCase(removePOExtraCloth.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchTempBaleLump.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTempBaleLump.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tempBale = action.payload;
        });
        builder.addCase(fetchTempBaleLump.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default poNoSlice.reducer;
